import { render, staticRenderFns } from "./kanbanonexl.vue?vue&type=template&id=5e65d162&scoped=true"
import script from "./kanbanonexl.vue?vue&type=script&lang=js"
export * from "./kanbanonexl.vue?vue&type=script&lang=js"
import style0 from "./kanbanonexl.vue?vue&type=style&index=0&id=5e65d162&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e65d162",
  null
  
)

export default component.exports